import React from "react";
import Button from "../button";
import moment from "moment";
import FormGroupPlainText from "../formGroupPlainText";
import FormGroupRadioInput from "../formGroupRadioInput";
import FormResponseMessage from "../formResponseMessage";
import {TEXT_CONFIRM_SOLICITOR_GROUP_UPDATE, TEXT_DECLINE_SOLICITOR_GROUP_UPDATE} from "../../helpers/variables";

class SolicitorGroupRemoveUnderwriterConfirmation extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            form: {
                updateRelatedPolicies: null,
            },
            errorMessage: null,
        }
    }

    handleRemove = (evt) => {
        evt.preventDefault();

        // user has selected a valid from date in the past that may affect policies without answering if he indeed
        // wants to update possible related live policies
        if(!this.state.form.updateRelatedPolicies) {
            return this.setState({
                errorMessage: 'You have to specify if you want to update all policies'
            });

        }

        this.props.removeUnderwriter(
            this.props.deletingUWAtRowIndex,
            this.state.form.updateRelatedPolicies === 'yes'
        );
    }

    handleRadioSelect = (evt) => {
        this.setState({
            form: {
                ...this.state.form,
                [evt.target.name]: evt.target.value
            }
        });
    }

    render() {
        return (
            <div className={'form-horizontal'}>
                <div>
                    <FormGroupPlainText
                        leftWrapper={"col-sm-12"}
                        Label={'There may be existing policies linked to the underwriters after removal, by continuing these policies will be updated with a new underwriter. Do you want to update all policies in this date range?'}
                    />
                    <FormGroupRadioInput
                        value={this.state.form.updateRelatedPolicies}
                        name={'updateRelatedPolicies'}
                        inputWrapper={'col-sm-12'}
                        onChange={this.handleRadioSelect}
                        options={[
                            {
                                key: 'yes',
                                label: TEXT_CONFIRM_SOLICITOR_GROUP_UPDATE
                                    .replace('__date__', this.props.previousFromLastItemValidFromDate)
                            },
                            {
                                key: 'no',
                                label: TEXT_DECLINE_SOLICITOR_GROUP_UPDATE
                            }
                        ]}
                    />
                </div>
                {
                    this.state.errorMessage && (
                        <FormResponseMessage
                            Message={this.state.errorMessage}
                            LeftWrapper="col-sm-3"
                            CenterWrapper="col-sm-6 "
                            MessageStyle="formResponseMessage-reject"
                        />
                    )
                }
                <div className={'form-group'}>
                    <div className={'col-sm-9 col-sm-offset-3'}>
                        <Button
                            clickHandler={this.handleRemove}
                            type={'submit'}
                            wrapper="btn-wrapper"
                            btnType="button"
                            btnStyle={'btn btn-primary btn-xs sharp yellow'}
                            label="Remove"
                        />
                    </div>
                </div>
            </div>
        )
    }
}

export default SolicitorGroupRemoveUnderwriterConfirmation;